import CustomButton from "../../components/CustomButton/Button";
import { Typography, Alert } from "antd";
import { BTN_TXT, TITLE_TXT, DESC_TXT } from "../../constants/constants";

const { Title } = Typography;

const KycStepContent = ({
  isUnderReview,
  isRejected,
  rejectedSteps,
  rejectReason,
  rejectedStepTitle,
  resubmitBtnText,
  onResubmitKyc,
  kycSteps,
  currentStep,
  handleStartKyc,
  handleMaybeLater,
  isManualMode,
  onSwitchToManual,
}) => {
  return (
    <>
      {isRejected && !isUnderReview && (
        <div className="review-message rejection-message" style={{ width: "100%", maxWidth: 650, margin: "0 auto" }}>
          {rejectedSteps && rejectedSteps.length > 0 ? (
            rejectedSteps.map((stepItem, idx) => (
              <div
                key={idx}
                style={{
                  marginBottom: 20,
                  padding: 20,
                  background: "#fff2f0",
                  border: "1px solid #ffccc7",
                  borderRadius: 8,
                  textAlign: "left",
                }}
              >
                <Title level={4} style={{ color: "#ff4d4f", marginTop: 0, marginBottom: 8 }}>
                  {stepItem.title} Rejected
                </Title>
                <Alert
                  message="Rejection Reason"
                  description={stepItem.reason}
                  type="error"
                  showIcon
                  style={{ marginBottom: 16 }}
                />
                <CustomButton
                  type="primary"
                  disabled={stepItem.isDisabled}
                  onClick={() => onResubmitKyc(stepItem.targetStep)}
                >
                  {stepItem.btnText}
                </CustomButton>
                {stepItem.isDisabled && (
                  <p style={{ fontSize: 12, color: "#ff4d4f", marginTop: 8, marginBottom: 0 }}>
                    Please re-submit previous rejected step(s) first.
                  </p>
                )}
              </div>
            ))
          ) : (
            <>
              <Title level={4} style={{ color: "#ff4d4f" }}>
                {rejectedStepTitle || "KYC Verification Rejected"}
              </Title>
              <Alert
                message="Rejection Reason"
                description={rejectReason || "Your submitted documents were rejected during manual review."}
                type="error"
                showIcon
                style={{ marginTop: 12, marginBottom: 20, textAlign: "left" }}
              />
              <CustomButton type="primary" onClick={() => onResubmitKyc(0)}>
                {resubmitBtnText || "Re-submit KYC"}
              </CustomButton>
            </>
          )}

          <div>
            <CustomButton
              style={{ marginTop: 16 }}
              color="purple"
              variant="outlined"
              onClick={handleMaybeLater}
            >
              {BTN_TXT.MAYBE_LATER}
            </CustomButton>
          </div>
        </div>
      )}

      {!isUnderReview && !isManualMode && !isRejected && (
        <>
          <div className="step-content">
            <p>{kycSteps[currentStep]?.content}</p>
            <CustomButton type="primary" onClick={handleStartKyc}>
              {BTN_TXT.LETS_START_BTN_TEXT}
            </CustomButton>
          </div>

          <div className="manual-switch-link">
            <CustomButton type="link" onClick={onSwitchToManual}>
              Having trouble? {BTN_TXT.SWITCH_MANUAL}
            </CustomButton>
          </div>
          <CustomButton
            style={{ marginTop: 16 }}
            color="purple"
            variant="outlined"
            onClick={handleMaybeLater}
          >
            {BTN_TXT.MAYBE_LATER}
          </CustomButton>
        </>
      )}

      {isUnderReview && (
        <div className="review-message">
          <Title level={4}>{TITLE_TXT.REVIEW_INFO_TITLE}</Title>
          <p>{DESC_TXT.REVIEW_INFO_DESC}</p>
          <CustomButton
            style={{ marginTop: 16 }}
            color="purple"
            variant="outlined"
            onClick={handleMaybeLater}
          >
            {BTN_TXT.MAYBE_LATER}
          </CustomButton>
        </div>
      )}
    </>
  );
};

export default KycStepContent;
